import { render, staticRenderFns } from "./home-process.vue?vue&type=template&id=0e80d0c4&scoped=true"
import script from "./home-process.vue?vue&type=script&lang=js"
export * from "./home-process.vue?vue&type=script&lang=js"
import style0 from "./home-process.vue?vue&type=style&index=0&id=0e80d0c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e80d0c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e80d0c4')) {
      api.createRecord('0e80d0c4', component.options)
    } else {
      api.reload('0e80d0c4', component.options)
    }
    module.hot.accept("./home-process.vue?vue&type=template&id=0e80d0c4&scoped=true", function () {
      api.rerender('0e80d0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/home-process.vue"
export default component.exports